/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Sheet } from "./Sheet";
export const SheetResponse = core.serialization.object({
    data: Sheet,
});
